import { render } from "./WhatsAppBroadcastRecipientsView.vue?vue&type=template&id=43c48a04&scoped=true"
import script from "./WhatsAppBroadcastRecipientsView.vue?vue&type=script&lang=js"
export * from "./WhatsAppBroadcastRecipientsView.vue?vue&type=script&lang=js"

import "./WhatsAppBroadcastRecipientsView.vue?vue&type=style&index=0&id=43c48a04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c48a04"]])

export default __exports__